import {
    Component,
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    Input,
    OnDestroy,
    OnInit,
    ViewContainerRef
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {distinctUntilChanged, map, take, takeUntil} from 'rxjs/operators';
import {combineLatest, Subject} from 'rxjs';
import {SpecialistsProvider} from '@providers/specialists/specialists.provider';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {SpecialistChoseModalComponent} from '../specialist-chose-modal/specialist-chose-modal.component';
import {SpecialistEnums} from '@namespaces/specialist.namespace';
import {FormHelperService} from '@services/form-helper.service';

@Component({
    selector: 'app-specialist-control-select',
    templateUrl: 'specialist-control-select.component.html'
})

export class SpecialistControlSelectComponent implements OnInit, OnDestroy {

    @Input() fbControl = new FormControl();

    public specialist: SpecialistViewInterface;

    public isFired = false;

    private destroyed$ = new Subject();

    private factory: ComponentFactory<SpecialistChoseModalComponent>;

    private componentRef: ComponentRef<SpecialistChoseModalComponent>;

    constructor(
        private specialistsProvider: SpecialistsProvider,
        private viewContainer: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
    ) {
    }

    ngOnInit() {
        this.factory = this.resolver.resolveComponentFactory(SpecialistChoseModalComponent);

        combineLatest(
            this.fbControl.valueChanges.pipe(distinctUntilChanged()),
            this.specialistsProvider.data$,
        ).pipe(
            takeUntil(this.destroyed$),
            map((value) => this.specialistsProvider.getById(value[0]) || null)
        ).subscribe((specialist: SpecialistViewInterface|null) => {
            this.specialist = specialist;

            this.isFired = this.specialist && this.specialist.status === SpecialistEnums.Status.fired;
        });

        this.fbControl.updateValueAndValidity();
    }

    onSelectClick() {
        /**
         * Динамически инициализируем компонент редактирования карточки оборудования
         */
        if (this.componentRef) {
            this.destroyComponentRef();
        }
        this.componentRef = this.viewContainer.createComponent(this.factory);

        this.componentRef.instance.show(+this.fbControl.value);

        this.componentRef.instance.chosenId$.pipe(
            takeUntil(this.destroyed$),
            take(1),
        ).subscribe((id: number) => {
            if (id) {
                FormHelperService.updateWithTouch(this.fbControl, id);
            }
            this.destroyComponentRef();
        });
    }

    clear() {
        FormHelperService.updateWithTouch(this.fbControl, null);
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }

    private destroyComponentRef() {
        this.componentRef.destroy();
        this.componentRef = null;
    }
}
